module.exports = __webpack_public_path__ + "fridayfive_template_monochrome_palette_facebook_cover.jpg?7b4c9e66126dd8a06e3e1471693f2c92";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/digital _factory/fridayfive_template_monochrome_palette_facebook_cover.jpg
// module id = 53
// module chunks = 0